import { quoteLiteral } from '@cli-utils/text.js'

export function formatArray(values: string[]): string {
  if (values.length === 0) {
    return '[]'
  }

  return `[${values.map((value) => quoteLiteral(value)).join(', ')}]`
}
